<div aria-label="status" class="log-status">
    @if (this.status === 'E') {
        <div class="info error" selected>
            <span class="material-symbols-outlined">close</span>
            <p>Erro</p>
        </div>
    }
    @if (this.status === 'W') {
        <div class="info warning" selected>
            <span class="material-symbols-outlined">warning</span>
            <p>Aviso</p>
        </div>
    }
    @if (this.status === 'S') {
        <div class="info success" selected>
            <span class="material-symbols-outlined">check</span>
            <p>Sucesso</p>
        </div>
    }
</div>
